<template>
  <b-card no-body>
    <b-card-header class="pb-50"></b-card-header>
    <b-card-body>
      <center>
        <b-link class="brand-logo mb-3">
            <b-img
              fluid
              :src="imgUrl"
              alt="Login V2"
              width="250"
            />
        </b-link>
    </center>
    <br>
      <center>
          <b-card-title>
            <h2><b>Surat Rekomendasi (Recommendation Form) Online</b></h2>
            <h3>{{ appName }} Fakultas Psikologi Universitas Indonesia</h3>
          </b-card-title>
          <br><br>
          <div class="mb-3">
              <center>
                <!-- <b-avatar
                  size="32"
                  :src="data.item.avatar"
                  :text="avatarText(data.item.name)"
                  :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                  title="Lihat Profil"
                /> -->
                <div class="d-flex justify-content-center">  
                  <b-avatar
                    size="80"
                    :text="rawData.nama.charAt(0)"
                    :variant="`light-primary`"
                    title="Picture"
                  />
                  <div class="mt-1 ml-1" style="text-align: left;">  
                    <h4>{{ rawData.nama }}</h4>
                    <div class="d-flex">  
                      <feather-icon icon="EditIcon" style="margin-right: 5px;" /><h5 class="mr-2"> Nomor Ujian : {{ rawData.nomor_ujian }}</h5>
                      <feather-icon icon="MailIcon" style="margin-right: 5px;" /><h5> Email : {{ rawData.email }}</h5>
                    </div>
                  </div>
                </div>
              </center>
            </div>
        </center>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton,BCardTitle,BImg,BLink,BAvatar
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store/index'
import {
  getPertanyaanPerekomendasi
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BCardTitle,
    BImg,
    BLink,
    BAvatar,
  },
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      rawData: {},
      filter: {},
      count: 0,
      sideImg: require('@/assets/images/logo/logo.png'),
    }
  },
  mounted() {
    getPertanyaanPerekomendasi(this.$route.params.token)
      .then(response => {
        if (response.data.success == true) {
          this.rawData = response.data.data.rekomendasi_token
        }
      })
      .catch(error => console.log(error));
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  methods: {
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
